import script from "./ImageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageItem.vue?vue&type=script&setup=true&lang=js"

import "./ImageItem.vue?vue&type=style&index=0&id=501c8131&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501c8131"]])

export default __exports__